/**
 * @generated SignedSource<<73b702c84022e010a69d73c88ce62abf>>
 * @relayHash 46e0df378b69357f328e48861fc763ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 87cfa88d6d8c89f0cbbd3692184fd11eb65624aedfd921e5a7ce011b66657577

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SpaceSidebarLinkType = "EXTERNAL_LINK" | "FORGE" | "PINNED_ATTACHMENT" | "PINNED_BLOG_POST" | "PINNED_PAGE" | "PINNED_SPACE" | "PINNED_USER_INFO" | "WEB_ITEM" | "%future added value";
export type SpaceViewsPersistenceOption = "POPULARITY" | "RECENTLY_MODIFIED" | "RECENTLY_VIEWED" | "TITLE_AZ" | "TREE" | "%future added value";
export type SpaceNavigationQuery$variables = {
  blogFirst?: number | null;
  blogOrderBy?: string | null;
  blogStatuses?: ReadonlyArray<string | null> | null;
  cloudId: string;
  contentId?: string | null;
  includeBlogTree?: boolean | null;
  includeHomepageTreeVariant?: boolean | null;
  includePageTree?: boolean | null;
  includePersistentInviteLicense?: boolean | null;
  includeSpaceCreationEligibility?: boolean | null;
  includeSpaceCurationCount?: boolean | null;
  includeSpaceViewsPersistence?: boolean | null;
  isLicensed: boolean;
  isSuperAdmin?: boolean | null;
  paginationLimit?: number | null;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null> | null;
  spaceKey: string;
};
export type SpaceNavigationQuery$data = {
  readonly blogPosts?: {
    readonly nodes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"BlogTreeRootComponent_content">;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly creationEligibilitySpace?: {
    readonly " $fragmentSpreads": FragmentRefs<"SpaceCreationEligibility_space">;
  } | null;
  readonly currentPage?: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly homepageRootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly license?: {
    readonly " $fragmentSpreads": FragmentRefs<"PersistentInviteEligibleQuery_license">;
  } | null;
  readonly rootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser?: {
      readonly isAdmin: boolean;
      readonly isFavourited: boolean;
      readonly isWatched: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
    } | null;
    readonly status: string | null;
    readonly type: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ExternalCollaboratorsSpaceInformationMessage_space" | "PersistentInviteEligibleQuery_space" | "SpaceHeader_space" | "SpaceOperationsFragment" | "useIsUserViewingSpaceAsAnon_space" | "useSpaceViewsData_space">;
  } | null;
  readonly spaceCurationSuggestionCount?: {
    readonly " $fragmentSpreads": FragmentRefs<"useFetchSuggestionCount_query">;
  } | null;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null;
        readonly isDefault: boolean | null;
        readonly path: string;
        readonly width: number | null;
      } | null;
      readonly iconClass: string | null;
      readonly id: string;
      readonly linkIdentifier: string | null;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly tooltip: string | null;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null;
      readonly webItemCompleteKey: string | null;
      readonly webItemKey: string | null;
    } | null> | null;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"ShortcutsSection_spaceSidebarLinks" | "SpaceLinks_spaceSidebarLinks">;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
  readonly userPreferences?: {
    readonly " $fragmentSpreads": FragmentRefs<"useSpaceViewsOptionsPersistence_userPreferences">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BlogTreeInitialData_query" | "PageTreeInitialData_query">;
};
export type SpaceNavigationQuery$rawResponse = {
  readonly blogPosts?: {
    readonly nodes: ReadonlyArray<{
      readonly blank: boolean;
      readonly id: string | null;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly metadata: {
        readonly createdDate: string | null;
        readonly lastModifiedDate: string | null;
      };
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly status: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
  readonly confluence_remoteObjectSuggestionCount?: number | null;
  readonly creationEligibilitySpace?: {
    readonly didContainUserContent: boolean;
    readonly id: string | null;
    readonly key: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isBlogsEnabled: boolean;
        readonly isDatabasesEnabled: boolean;
        readonly isEmbedsEnabled: boolean;
        readonly isFoldersEnabled: boolean;
        readonly isLivePagesEnabled: boolean;
        readonly isSlidesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
  } | null;
  readonly currentPage?: {
    readonly blank: boolean | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly blank: boolean | null;
            readonly createdDate: {
              readonly value: string;
            } | null;
            readonly hasChildren: boolean;
            readonly hasInheritedRestrictions?: boolean;
            readonly hasRestrictions?: boolean;
            readonly id: string;
            readonly links: {
              readonly webui: string | null;
            } | null;
            readonly properties: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null;
                readonly key: string | null;
                readonly value: string | null;
                readonly version: {
                  readonly number: number | null;
                } | null;
              } | null> | null;
            } | null;
            readonly status: PTGraphQLPageStatus | null;
            readonly subType: string | null;
            readonly title: string | null;
            readonly type: string | null;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly homepageRootPageTree?: {
    readonly blank: boolean | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly license?: {
    readonly licenseConsumingUserCount: number;
    readonly trialEndDate: string | null;
  } | null;
  readonly rootPageTree?: {
    readonly blank: boolean | null;
    readonly createdDate: {
      readonly value: string;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly blank: boolean | null;
        readonly createdDate: {
          readonly value: string;
        } | null;
        readonly hasChildren: boolean;
        readonly hasInheritedRestrictions?: boolean;
        readonly hasRestrictions?: boolean;
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly hasChildren: boolean;
    readonly hasInheritedRestrictions?: boolean;
    readonly hasRestrictions?: boolean;
    readonly id: string;
    readonly links: {
      readonly webui: string | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly status: PTGraphQLPageStatus | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser: {
      readonly isAdmin: boolean;
      readonly isAnonymouslyAuthorized: boolean;
      readonly isFavourited?: boolean;
      readonly isWatched?: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly externalCollaboratorCount: number;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly blank: boolean | null;
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly createdDate: {
        readonly value: string;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly hasChildren: boolean;
      readonly hasInheritedRestrictions?: boolean;
      readonly hasRestrictions?: boolean;
      readonly id: string;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null;
              readonly createdDate: {
                readonly value: string;
              } | null;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null;
              } | null;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null;
                  readonly key: string | null;
                  readonly value: string | null;
                  readonly version: {
                    readonly number: number | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly status: PTGraphQLPageStatus | null;
              readonly subType: string | null;
              readonly title: string | null;
              readonly type: string | null;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly blank: boolean | null;
              readonly createdDate: {
                readonly value: string;
              } | null;
              readonly hasChildren: boolean;
              readonly hasInheritedRestrictions?: boolean;
              readonly hasRestrictions?: boolean;
              readonly id: string;
              readonly links: {
                readonly webui: string | null;
              } | null;
              readonly properties: {
                readonly nodes: ReadonlyArray<{
                  readonly id: string | null;
                  readonly key: string | null;
                  readonly value: string | null;
                  readonly version: {
                    readonly number: number | null;
                  } | null;
                } | null> | null;
              } | null;
              readonly status: PTGraphQLPageStatus | null;
              readonly subType: string | null;
              readonly title: string | null;
              readonly type: string | null;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly blank: boolean | null;
          readonly createdDate: {
            readonly value: string;
          } | null;
          readonly hasChildren: boolean;
          readonly hasInheritedRestrictions?: boolean;
          readonly hasRestrictions?: boolean;
          readonly id: string;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly id: string | null;
              readonly key: string | null;
              readonly value: string | null;
              readonly version: {
                readonly number: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly status: PTGraphQLPageStatus | null;
          readonly subType: string | null;
          readonly title: string | null;
          readonly type: string | null;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly status: PTGraphQLPageStatus | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null;
    readonly status: string | null;
    readonly type: string | null;
  } | null;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null;
        readonly isDefault: boolean | null;
        readonly path: string;
        readonly width: number | null;
      } | null;
      readonly iconClass: string | null;
      readonly id: string;
      readonly linkIdentifier: string | null;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly tooltip: string | null;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null;
      readonly webItemCompleteKey: string | null;
      readonly webItemKey: string | null;
    } | null> | null;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
  readonly userPreferences?: {
    readonly spaceViewsPersistence: SpaceViewsPersistenceOption;
  } | null;
};
export type SpaceNavigationQuery = {
  rawResponse: SpaceNavigationQuery$rawResponse;
  response: SpaceNavigationQuery$data;
  variables: SpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 40,
  "kind": "LocalArgument",
  "name": "blogFirst"
},
v1 = {
  "defaultValue": "metadata.createdDate desc",
  "kind": "LocalArgument",
  "name": "blogOrderBy"
},
v2 = {
  "defaultValue": [
    "current",
    "draft"
  ],
  "kind": "LocalArgument",
  "name": "blogStatuses"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBlogTree"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeHomepageTreeVariant"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePageTree"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePersistentInviteLicense"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceCreationEligibility"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceCurationCount"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceViewsPersistence"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v17 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v18 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "spaceKey"
},
v19 = [
  (v17/*: any*/),
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v20/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v22 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v23 = [
  (v22/*: any*/)
],
v24 = [
  {
    "kind": "Literal",
    "name": "includeHidden",
    "value": true
  }
],
v25 = {
  "kind": "ScalarField",
  "name": "webItemKey"
},
v26 = {
  "kind": "ScalarField",
  "name": "webItemCompleteKey"
},
v27 = {
  "kind": "ScalarField",
  "name": "title"
},
v28 = {
  "kind": "ScalarField",
  "name": "url"
},
v29 = {
  "kind": "ScalarField",
  "name": "position"
},
v30 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v31 = {
  "kind": "ScalarField",
  "name": "path"
},
v32 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    {
      "kind": "ScalarField",
      "name": "width"
    },
    {
      "kind": "ScalarField",
      "name": "height"
    },
    {
      "kind": "ScalarField",
      "name": "isDefault"
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "iconClass"
},
v34 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v35 = {
  "kind": "ScalarField",
  "name": "canHide"
},
v36 = {
  "kind": "ScalarField",
  "name": "tooltip"
},
v37 = {
  "kind": "ScalarField",
  "name": "linkIdentifier"
},
v38 = {
  "kind": "ScalarField",
  "name": "type"
},
v39 = {
  "concreteType": "SpaceSidebarLink",
  "kind": "LinkedField",
  "name": "quick",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v27/*: any*/),
    (v30/*: any*/)
  ]
},
v40 = [
  (v18/*: any*/)
],
v41 = {
  "kind": "ScalarField",
  "name": "key"
},
v42 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "homepage",
  "plural": false,
  "selections": [
    (v20/*: any*/)
  ]
},
v43 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "didContainUserContent"
},
v45 = {
  "kind": "ScalarField",
  "name": "name"
},
v46 = {
  "kind": "ScalarField",
  "name": "status"
},
v47 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v31/*: any*/)
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "homepageId"
},
v49 = {
  "kind": "ScalarField",
  "name": "isAdmin"
},
v50 = {
  "kind": "ScalarField",
  "name": "isFavourited"
},
v51 = {
  "kind": "ScalarField",
  "name": "isWatched"
},
v52 = {
  "kind": "ScalarField",
  "name": "containsExternalCollaborators"
},
v53 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v54 = {
  "concreteType": "SpaceHistory",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    (v53/*: any*/)
  ]
},
v55 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v56 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v57 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v58 = [
  (v55/*: any*/),
  (v56/*: any*/),
  (v57/*: any*/)
],
v59 = {
  "kind": "FragmentSpread",
  "name": "PageTreeQuery_ptpage"
},
v60 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v61 = [
  (v60/*: any*/),
  {
    "kind": "ScalarField",
    "name": "endCursor"
  }
],
v62 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": (v61/*: any*/)
},
v63 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v60/*: any*/)
  ]
},
v64 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v59/*: any*/)
    ]
  },
  (v63/*: any*/)
],
v65 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v64/*: any*/)
},
v67 = [
  (v59/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v62/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v59/*: any*/),
          (v65/*: any*/),
          (v66/*: any*/)
        ]
      }
    ]
  },
  (v65/*: any*/),
  (v66/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v64/*: any*/)
  }
],
v68 = [
  (v55/*: any*/),
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  (v56/*: any*/),
  (v22/*: any*/),
  (v57/*: any*/)
],
v69 = [
  (v55/*: any*/),
  (v56/*: any*/),
  (v22/*: any*/),
  (v57/*: any*/)
],
v70 = [
  (v59/*: any*/),
  (v66/*: any*/)
],
v71 = [
  (v22/*: any*/),
  (v57/*: any*/)
],
v72 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "blogFirst"
  },
  {
    "kind": "Variable",
    "name": "orderby",
    "variableName": "blogOrderBy"
  },
  (v22/*: any*/),
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "blogStatuses"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "blogpost"
  }
],
v73 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": (v61/*: any*/)
},
v74 = {
  "kind": "ScalarField",
  "name": "value"
},
v75 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v74/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v76 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v77 = {
  "kind": "ScalarField",
  "name": "blank"
},
v78 = {
  "kind": "ScalarField",
  "name": "subType"
},
v79 = [
  {
    "kind": "ScalarField",
    "name": "webui"
  }
],
v80 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": (v79/*: any*/)
},
v81 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor",
        "jira-planner-connection"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v41/*: any*/),
        (v74/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
},
v82 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v83 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v20/*: any*/),
      (v27/*: any*/),
      (v46/*: any*/),
      (v75/*: any*/),
      (v76/*: any*/),
      (v77/*: any*/),
      (v38/*: any*/),
      (v78/*: any*/),
      (v80/*: any*/),
      (v81/*: any*/),
      (v82/*: any*/)
    ]
  },
  (v63/*: any*/)
],
v84 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v83/*: any*/)
},
v85 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v83/*: any*/)
},
v86 = [
  (v20/*: any*/),
  (v27/*: any*/),
  (v46/*: any*/),
  (v75/*: any*/),
  (v76/*: any*/),
  (v77/*: any*/),
  (v38/*: any*/),
  (v78/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v82/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v62/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v20/*: any*/),
          (v27/*: any*/),
          (v46/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/),
          (v77/*: any*/),
          (v38/*: any*/),
          (v78/*: any*/),
          (v80/*: any*/),
          (v81/*: any*/),
          (v82/*: any*/),
          (v84/*: any*/),
          (v85/*: any*/)
        ]
      }
    ]
  },
  (v84/*: any*/),
  (v85/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v83/*: any*/)
  }
],
v87 = [
  (v20/*: any*/),
  (v27/*: any*/),
  (v46/*: any*/),
  (v75/*: any*/),
  (v76/*: any*/),
  (v77/*: any*/),
  (v38/*: any*/),
  (v78/*: any*/),
  (v80/*: any*/),
  (v81/*: any*/),
  (v82/*: any*/),
  (v85/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceNavigationQuery",
    "selections": [
      {
        "condition": "includeSpaceCreationEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "creationEligibilitySpace",
            "args": (v19/*: any*/),
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SpaceCreationEligibility_space"
              }
            ]
          }
        ]
      },
      (v21/*: any*/),
      {
        "args": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "includeHomepageTreeVariant",
            "variableName": "includeHomepageTreeVariant"
          },
          {
            "kind": "Variable",
            "name": "includePageTree",
            "variableName": "includePageTree"
          },
          {
            "kind": "Variable",
            "name": "isSuperAdmin",
            "variableName": "isSuperAdmin"
          },
          {
            "kind": "Variable",
            "name": "paginationLimit",
            "variableName": "paginationLimit"
          },
          {
            "kind": "Variable",
            "name": "ptStatuses",
            "variableName": "ptStatuses"
          },
          (v22/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PageTreeInitialData_query"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "blogFirst",
            "variableName": "blogFirst"
          },
          {
            "kind": "Variable",
            "name": "blogOrderBy",
            "variableName": "blogOrderBy"
          },
          {
            "kind": "Variable",
            "name": "blogStatuses",
            "variableName": "blogStatuses"
          },
          {
            "kind": "Variable",
            "name": "includeBlogTree",
            "variableName": "includeBlogTree"
          },
          (v22/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BlogTreeInitialData_query"
      },
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "useFetchSuggestionCount_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "spaceCurationSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PersistentInviteEligibleQuery_license"
              }
            ]
          }
        ]
      },
      {
        "args": (v23/*: any*/),
        "concreteType": "SpaceSidebarLinks",
        "kind": "LinkedField",
        "name": "spaceSidebarLinks",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SpaceLinks_spaceSidebarLinks"
          },
          {
            "kind": "FragmentSpread",
            "name": "ShortcutsSection_spaceSidebarLinks"
          },
          {
            "args": (v24/*: any*/),
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": "main(includeHidden:true)"
          },
          (v39/*: any*/)
        ]
      },
      {
        "args": (v40/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "useIsUserViewingSpaceAsAnon_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "PersistentInviteEligibleQuery_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isLicensed",
                "variableName": "isLicensed"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SpaceHeader_space"
          },
          (v20/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "SpaceOperationsFragment"
          },
          (v44/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "useSpaceViewsData_space"
          },
          (v45/*: any*/),
          (v38/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/)
                ]
              }
            ]
          },
          (v52/*: any*/),
          (v54/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v58/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v67/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v68/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v67/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v69/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v70/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v71/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v70/*: any*/)
          }
        ]
      },
      {
        "condition": "includeBlogTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "blogPosts",
            "args": (v72/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v73/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "BlogTreeRootComponent_content"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceViewsPersistence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "useSpaceViewsOptionsPersistence_userPreferences"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v16/*: any*/),
      (v12/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v11/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v21/*: any*/),
      {
        "args": (v40/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
              },
              (v49/*: any*/)
            ]
          },
          (v45/*: any*/),
          {
            "kind": "ScalarField",
            "name": "externalCollaboratorCount"
          },
          (v41/*: any*/),
          (v38/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v52/*: any*/),
          (v44/*: any*/),
          (v48/*: any*/),
          (v54/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v58/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v86/*: any*/)
              }
            ]
          },
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v50/*: any*/),
                  (v51/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v23/*: any*/),
        "concreteType": "SpaceSidebarLinks",
        "kind": "LinkedField",
        "name": "spaceSidebarLinks",
        "plural": false,
        "selections": [
          {
            "args": (v24/*: any*/),
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v26/*: any*/),
              (v29/*: any*/),
              (v34/*: any*/),
              (v25/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/)
            ],
            "storageKey": "main(includeHidden:true)"
          },
          (v39/*: any*/)
        ]
      },
      {
        "condition": "includeSpaceCreationEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "creationEligibilitySpace",
            "args": (v19/*: any*/),
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              (v20/*: any*/),
              {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isLivePagesEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isWhiteboardsEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDatabasesEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isBlogsEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEmbedsEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isSlidesEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFoldersEnabled"
                      }
                    ]
                  }
                ]
              },
              (v44/*: any*/),
              (v43/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v68/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v86/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v69/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v87/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v71/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v87/*: any*/)
          }
        ]
      },
      {
        "condition": "includeBlogTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "blogPosts",
            "args": (v72/*: any*/),
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v73/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v27/*: any*/),
                  (v46/*: any*/),
                  (v77/*: any*/),
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                          "emoji-title-published",
                          "emoji-title-draft",
                          "editor"
                        ]
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v20/*: any*/),
                          (v41/*: any*/),
                          (v74/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                  },
                  {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": (v79/*: any*/)
                  },
                  {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                      },
                      (v53/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v17/*: any*/),
              (v22/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "licenseConsumingUserCount"
              },
              {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceViewsPersistence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
              {
                "args": (v23/*: any*/),
                "kind": "ScalarField",
                "name": "spaceViewsPersistence"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "46e0df378b69357f328e48861fc763ec",
    "id": "87cfa88d6d8c89f0cbbd3692184fd11eb65624aedfd921e5a7ce011b66657577",
    "metadata": {},
    "name": "SpaceNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false,$includeBlogTree:Boolean=false,$blogFirst:Int=40,$blogOrderBy:String=\"metadata.createdDate desc\",$blogStatuses:[String]=[\"current\",\"draft\"],$includeSpaceViewsPersistence:Boolean=false,$includeSpaceCreationEligibility:Boolean=false){creationEligibilitySpace:space(cloudId:$cloudId,key:$spaceKey)@include(if:$includeSpaceCreationEligibility){...SpaceCreationEligibility_space,id},user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...PageTreeInitialData_query_4jV106,...BlogTreeInitialData_query_2C9WBt,...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license},spaceSidebarLinks(spaceKey:$spaceKey){...SpaceLinks_spaceSidebarLinks,...ShortcutsSection_spaceSidebarLinks,main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,...useSpaceViewsData_space,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{...BlogTreeRootComponent_content,id}},userPreferences@include(if:$includeSpaceViewsPersistence){...useSpaceViewsOptionsPersistence_userPreferences}}fragment BlogTreeInitialData_query_2C9WBt on Query{blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}fragment BlogTreeRootComponent_content on Content{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}fragment ContextualCreateContentButton_space on Space{id,operations{operation,targetType}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment FooterCreateButtons_space on Space{id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}fragment PageTreeInitialData_query_4jV106 on Query{currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment ShortcutsSection_spaceSidebarLinks on SpaceSidebarLinks{quick{id,url,position,title,styleClass}}fragment SpaceCreationEligibility_space on Space{key,...FooterCreateButtons_space,...useSpaceEnabledContentTypes_space,...ContextualCreateContentButton_space}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceLinks_spaceSidebarLinks on SpaceSidebarLinks{main(includeHidden:true){id,webItemCompleteKey,position,hidden}}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment useSpaceEnabledContentTypes_space on Space{id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}fragment useSpaceViewsData_space on Space{id,homepage{id},operations{operation,targetType}}fragment useSpaceViewsOptionsPersistence_userPreferences on UserPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}"
  }
};
})();

(node as any).hash = "1cc5d8067735fae3f4972376c1268473";

export default node;
